import { Pipe, PipeTransform } from '@angular/core';
import min from 'date-fns/min';
import format from 'date-fns/format';
import { parsedOutput } from '../helper-functions';
import { DatePipeManager } from '../providers/date-pipe-manager';
export class MinDatePipe implements PipeTransform {
/**
 * Returns the min date from a range of dates
 * @param {?} manager
 */
constructor(private manager: DatePipeManager) {}
/**
 * @param {?} range
 * @param {?=} dateFormat
 * @return {?}
 */
transform(range: Array<string | number | Date>, dateFormat?: string) {
    const /** @type {?} */ formatToUse = this.manager.getDefaultFormat(dateFormat);
    return format(min(...range), formatToUse);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'minDate',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatePipeManager, },
];
}

function MinDatePipe_tsickle_Closure_declarations() {
/** @type {?} */
MinDatePipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MinDatePipe.ctorParameters;
/** @type {?} */
MinDatePipe.prototype.manager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
